import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Import configs and util modules
import { FormattedMessage } from '../../../../util/reactIntl';
import { LISTING_STATE_DRAFT } from '../../../../util/types';

// Import shared components
import { H3 } from '../../../../components';

// Import modules from this directory
import css from './EditListingAppearancePanel.module.css';
import EditListingAppearanceForm from './EditListingAppearanceForm';

const EditListingAppearancePanel = props => {
  const {
    className,
    rootClassName,
    listing,
    disabled,
    ready,
    onSubmit,
    submitButtonText,
    panelUpdated,
    updateInProgress,
    errors,
  } = props;
  const { publicData } = listing.attributes || {};
  const { material, color, style, anyDamage, purchasedYear, productType } = publicData || {};
  const classes = classNames(rootClassName || css.root, className);
  const isPublished = listing?.id && listing?.attributes.state !== LISTING_STATE_DRAFT;

  return (
    <div className={classes}>
      <div className={css.container}>
        <H3 as="h1">
          <FormattedMessage
            id="EditListingAppearancePanel.createListingTitle"
            values={{ lineBreak: <br /> }}
          />
        </H3>
        <EditListingAppearanceForm
          className={css.form}
          initialValues={{
            material: { key: material, label: material },
            color: { key: color, label: color },
            style: { key: style, label: style },
            anyDamage, purchasedYear
          }}
          productType={productType}
          onSubmit={values => {
            const { material, color, style, anyDamage, purchasedYear } = values;
            // New values for listing attributes
            const updateValues = {
              publicData: {
                material: material?.label,
                color: color?.label,
                style: style?.label,
                anyDamage,
                purchasedYear,
                updatedAt: Math.floor(Date.now() / 1000),
              },
            };
            onSubmit(updateValues);
          }}
          saveActionMsg={submitButtonText}
          disabled={disabled}
          ready={ready}
          updated={panelUpdated}
          updateInProgress={updateInProgress}
          fetchErrors={errors}
          autoFocus
        />
      </div>
    </div>
  );
};

const { func, object, string, bool } = PropTypes;

EditListingAppearancePanel.defaultProps = {
  className: null,
  rootClassName: null,
  listing: null,
};

EditListingAppearancePanel.propTypes = {
  className: string,
  rootClassName: string,

  // We cannot use propTypes.listing since the listing might be a draft.
  listing: object,

  disabled: bool.isRequired,
  ready: bool.isRequired,
  onSubmit: func.isRequired,
  submitButtonText: string.isRequired,
  panelUpdated: bool.isRequired,
  updateInProgress: bool.isRequired,
  errors: object.isRequired,
};

export default EditListingAppearancePanel;
